require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MDXEmbedProvider = void 0;

var _react = require("@mdx-js/react");

var _react2 = _interopRequireDefault(require("react"));

var _buzzprout = require("../buzzprout");

var _cinnamon = require("../cinnamon");

var _codepen = require("../codepen");

var _codesandbox = require("../codesandbox");

var _egghead = require("../egghead");

var _flickr = require("../flickr");

var _gist = require("../gist");

var _instagram = require("../instagram");

var _lbry = require("../lbry");

var _pinterest = require("../pinterest");

var _simplecast = require("../simplecast");

var _soundcloud = require("../soundcloud");

var _spotify = require("../spotify");

var _strava = require("../strava");

var _tiktok = require("../tiktok");

var _twitch = require("../twitch");

var _twitter = require("../twitter");

var _vimeo = require("../vimeo");

var _wikipedia = require("../wikipedia");

var _youtube = require("../youtube");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var components = {
  Buzzprout: _buzzprout.Buzzprout,
  Cinnamon: _cinnamon.Cinnamon,
  CodePen: _codepen.CodePen,
  CodeSandbox: _codesandbox.CodeSandbox,
  EggheadLesson: _egghead.EggheadLesson,
  Flickr: _flickr.Flickr,
  Gist: _gist.Gist,
  Instagram: _instagram.Instagram,
  Lbry: _lbry.Lbry,
  Pin: _pinterest.Pin,
  PinterestBoard: _pinterest.PinterestBoard,
  PinterestFollowButton: _pinterest.PinterestFollowButton,
  SimplecastEpisode: _simplecast.SimplecastEpisode,
  SoundCloud: _soundcloud.SoundCloud,
  Spotify: _spotify.Spotify,
  Strava: _strava.Strava,
  TikTok: _tiktok.TikTok,
  Twitch: _twitch.Twitch,
  Tweet: _twitter.Tweet,
  TwitterFollowButton: _twitter.TwitterFollowButton,
  TwitterHashtagButton: _twitter.TwitterHashtagButton,
  TwitterList: _twitter.TwitterList,
  TwitterMentionButton: _twitter.TwitterMentionButton,
  TwitterTimeline: _twitter.TwitterTimeline,
  Vimeo: _vimeo.Vimeo,
  Wikipedia: _wikipedia.Wikipedia,
  YouTube: _youtube.YouTube
};

var MDXEmbedProvider = function MDXEmbedProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react2["default"].createElement(_react.MDXProvider, {
    components: components
  }, children);
};

exports.MDXEmbedProvider = MDXEmbedProvider;